import React from 'react';
import R from 'ramda';

export const getPricingChangesComponent = (amountChanges, percentChanges) => amountChanges || percentChanges ? (<span>
  &nbsp;Average
  {percentChanges ? ` ${percentChanges}% ` : ''}
  {amountChanges ? `(${amountChanges.slice(0, 1)}$${amountChanges.slice(1)})` : ''}
</span>) : '';
const getAverage = arrOfNum => arrOfNum.length ? (R.sum(arrOfNum) / (arrOfNum.length)).toFixed(2) : 0;
export const UpdateSummary = ({ updateSummary }) => {
  return (
    <ul style={{ marginLeft: '20px', lineHeight: '24px', fontSize: '14px', fontWeight: '400' }}>
      {
        updateSummary.map(summary => (
          <li key={summary.text}>
            {summary.text}
            {(Boolean(summary.subLabels && summary.subLabels.length) && (
              <ul style={{ marginLeft: '20px' }}>
                {
                  summary.subLabels.map(({ text, nettRate, retailRate }, subLabelIndex) => {
                    const rate = nettRate || retailRate;
                    return (
                      <li key={subLabelIndex}>
                        {text}
                        <div style={{ fontWeight: 'bold', fontSize: '12px' }}>{Boolean(rate) && getPricingChangesComponent(rate.amountDiff, rate.percentDiff)}</div>
                      </li>
                    )
                  })
                }
              </ul>
            ))}
          </li>
        ))
      }
    </ul>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/contracting-reports/diff-report/diffing/section-updateSummary.jsx